import globalAxios from "axios";

import { appendQueryArgs } from "utils/apiHelpers";
import { axios } from "utils/axios";
import config from "../../app.config";

const API_PATH = "/api/v1/";

axios.defaults.baseURL = config.apiUrl || "";
globalAxios.defaults.baseURL = config.apiUrl || "";

class API {
  constructor(args) {
    this.baseUrl = axios.defaults.baseURL + API_PATH;
    this.controller = args.controller;
    this.url = this.baseUrl + this.controller;
  }

  all(opts) {
    return axios.get(appendQueryArgs(this.url, opts));
  }

  csvExport(opts) {
    return axios.get(appendQueryArgs(`${this.url}/export_csv`, opts));
  }

  get(id, payload = undefined) {
    return axios.get(appendQueryArgs(`${this.url}/${id}`, payload));
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.put(`${this.url}/${id}`, payload);
  }

  destroy(id, payload = undefined) {
    if (payload) {
      return axios.delete(`${this.url}/${id}`, { data: payload });
    }
    return axios.delete(`${this.url}/${id}`);
  }

  csvFields(payload = undefined) {
    return axios.get(appendQueryArgs(`${this.url}/valid_csv_fields`, payload));
  }
}

export default API;
